export default __webpack_public_path__ + "static/media/notFoundDark.4ef2e9d3.svg";